import * as React from 'react';
import { useApplicationContext } from '../../utils/applicationContext';
import { isReliableBuilder } from './utils';
import { LabelBox } from '../../components/LabelBox';
import { IconTrust16 } from '@cian/ui-kit';
import { NBSP } from '../../constants/symbols';

interface ILabelContainerProps {
  builderId: number;
}

export const LabelContainer: React.FC<ILabelContainerProps> = ({ builderId }) => {
  const { config } = useApplicationContext();

  if (isReliableBuilder(builderId, config)) {
    return (
      <LabelBox
        text="Проверен Федерацией ИЖС"
        color="blue"
        tooltipTitle="Проверен Федерацией ИЖС"
        tooltipContent={`Эксперты Федерации ИЖС изучили опыт работы, репутацию компании, юридическую и${NBSP}финансовую отчётность`}
        icon={<IconTrust16 color="primary_100" />}
      />
    );
  }

  return null;
};
